import { pgTable, text, decimal } from 'drizzle-orm/pg-core'
import { getBaseFields, getBaseIndexes } from '../common/utils'

export const addresses = pgTable(
  'addresses',
  {
    ...getBaseFields(),
    street: text().notNull(),
    city: text().notNull(),
    postalCode: text(),
    country: text(),
    latitude: decimal({ precision: 10, scale: 8 }),
    longitude: decimal({ precision: 11, scale: 8 }),
    streetViewCameraLat: decimal({ precision: 10, scale: 8 }),
    streetViewCameraLng: decimal({ precision: 11, scale: 8 }),
    streetViewHeading: decimal({ precision: 5, scale: 2 }),
  },
  (table) => getBaseIndexes('addresses', table),
)
